import { commentsTypes } from '../types'

const initialState = {
  items: [],
  isRequesting: true,
  isError: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case commentsTypes.GET_COMMENTS__REQUEST: return {
      ...state,
      isError: false,
      isRequesting: true
    }
    case commentsTypes.GET_COMMENTS__SUCCESS: return {
      ...state,
      isRequesting: false,
      isError: false,
      items: action.payload.items
    }
    case commentsTypes.GET_COMMENTS__FAILURE: return {
      ...state,
      isRequesting: false,
      isError: true
    }
    default: return state
  }
}
